module.exports = __webpack_public_path__ + "static/media/stockhausen_graz_4.5f975ac3.jpg";